<template>
  <PageSlider></PageSlider>

  <!-- apresentação -->
  <section class="services-area gray-bg section-padding">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-12">
             <!-- detalhes -->
          <div v-if="apresentacaoDetalhes != ''" class="section-top-border">
            <div class="row d-flex">

              <div v-for="detalhes in apresentacaoDetalhes" :key="detalhes.itiId" class="col-md-3">
                <div class="single-defination img-detalhes">
                  <div><img :src="$imgURL + detalhes.insInstitucionalImagens[0].itgUrlImagem"
                      style="width: 80px; height: auto; padding-bottom: 15px;" /></div>
                  <h4 class="mb-20 linha alt-detalhes" >{{ detalhes.itiNome }}</h4>
                  <p v-html="detalhes.itiResumo1" style="padding-top: 10px;"></p>
                </div>
              </div>

            </div>
          </div>
          <!-- titulo e texto -->
          <div v-if="apresentacao != ''" class="row mb-25 txt-vert">
            <div class="col-xl-6 col-lg-6">
              <div class="section-tittle section-tittle3 pad-30">
                <h2 style="text-align: center;">{{ apresentacao[0].itiNome }}</h2>
                <p v-html="apresentacao[0].itiResumo1"></p>
              </div>
            </div>
            <!-- imagem -->
            <div class="col-xl-6 col-lg-6">
              <img :src="$imgURL + apresentacao[0].insInstitucionalImagens[0].itgUrlImagem" style="width: 100%;" class="img-cant-red"/>
            </div>
            
          </div>
       

        </div>
      </div>
    </div>
  </section>
  <!-- END apresentação -->

  <!-- depoimento -->
  <div v-if="depoimentos != ''" class="emargency-care section-img-bg2"
    style="background-image: url(/images/gallery/section-bg1.jpg);">
    <div class="container">
      <div class="row justify-content-end">
        <div class="col-xl-5 col-lg-6 col-md-9 col-sm-12">
          <div class="single-emargency">
            <Swiper :navigation="false" :pagination="{ clickable: true }" :slides-per-view="1" :space-between="40"
              :breakpoints="{ 768: { slidesPerView: 1 }, 0: { slidesPerView: 1 } }">
              <SwiperSlide v-for="textos in depoimentos" :key="textos.itiId">
                <div class="emargency-cap">
                  <div class="cat-icon">
                    <img src="/images/icon/message.svg" alt="">
                  </div>
                  <p v-html="textos.itiResumo1" class="emargenc-cap"></p>
                  <div class="ceo-name">
                    <span>{{ textos.itiNome }}</span>
                    <p>{{ textos.itiReferencia }}</p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END depoimento -->

  <!-- call to action -->
  <PageCallAction></PageCallAction>
  <!-- END call to action -->

  <!-- Scroll Up -->
  <div id="back-top">
    <a title="Go to Top" href="#"> <i class="fas fa-level-up-alt"></i></a>
  </div>

</template>

<script>
import { useHead } from '@vueuse/head';
import axios from 'axios';
import PageSlider from '@/components/PageSlider.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import PageCallAction from '@/components/PageCallAction.vue';

export default {
  name: 'HomeView',
  components: {
    PageSlider,
    Swiper,
    SwiperSlide,
    PageCallAction,
  },

  data: () => ({
    apresentacao: [],
    apresentacaoDetalhes: [],
    depoimentos: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto) {
      useHead({
        title: 'FiançAqui Garantidora - Home',
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "FiançAqui" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {

    this.carregaMetas("---");

    //aqui busca apresentação
    axios.get('/Process/InsInstitucional/institucional/38/apresentacao/0/x')
      .then(response => {
        this.apresentacao = response.data;
        //console.log('apresentacao')
        //console.log(this.apresentacao)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca apresentação detalhes 
    axios.get('/Process/InsInstitucional/institucional/39/apresentacaodetalhes/0/x')
      .then(response => {
        this.apresentacaoDetalhes = response.data;
        //console.log('apresentacaoDetalhes')
        //console.log(this.apresentacaoDetalhes)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca depoimentos
    axios.get('/Process/InsInstitucional/institucional/42/depoimentos/0/x')
      .then(response => {
        this.depoimentos = response.data;
        //console.log('depoimentos')
        //console.log(this.depoimentos)
      })
      .catch(error => {
        console.error(error);
      });

  },
}

</script>

<style scoped></style>
